module.exports = __webpack_public_path__ + "img/store-allocation.2a7095ac.png";